// components/BuilderTimeline/BuilderActivityItem.tsx

import React from 'react';
import { BuilderActivityRecord } from '../../providers/types';

interface BuilderActivityItemProps {
  activity: BuilderActivityRecord;
}

const formatDate = (dateString?: string | null): string => {
  if (!dateString) return '';
  
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();

    const hours24 = date.getHours();
    const hours12 = hours24 % 12 || 12;
    const period = hours24 >= 12 ? 'PM' : 'AM';
    const hours = String(hours12).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${month}/${day}/${year} ${hours}:${minutes}:${seconds} ${period}`;    
  } catch {
    return '';
  }
};

const formatCurrency = (amount?: number | null): string => {
  if (amount === null || amount === undefined) return '$0.00';
  
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const BuilderActivityItem: React.FC<BuilderActivityItemProps> = ({ activity }) => {
  const isCurrentBuilder = activity.recordType === 'CurrentBuilder';

  if (isCurrentBuilder) {
    return (
      <div className="builder-activity-item current-builder">
        <div className="current-builder-header">
          <span className="builder-icon">📌</span>
          <span className="current-label">CURRENT BUILDER</span>
        </div>
        <div className="builder-info">
          <div className="builder-name">{activity.builderName}</div>
          {activity.builderEmail && (
            <div className="builder-email">{activity.builderEmail}</div>
          )}
          {activity.employeeNumber && (
            <div className="builder-employee">Employee #: {activity.employeeNumber}</div>
          )}
          {activity.split !== null && activity.split !== undefined && (
            <div className="builder-split">
              Split: {activity.split}%: <strong>{formatCurrency(activity.splitAmount)}</strong>
            </div>
          )}
          {activity.deductionAmount !== null && activity.deductionAmount !== undefined && activity.deductionAmount >= 0 && (
            <div className="builder-deduction">
              Deductions: <strong>{formatCurrency(activity.deductionAmount)}</strong>
            </div>
          )}
          {activity.totalBonus !== null && activity.totalBonus !== undefined && (
            <div className="builder-total">
              Total Bonus: <strong>{formatCurrency(activity.totalBonus)}</strong>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="builder-activity-item history-activity">
      <div className="activity-header">
        <div className="activity-date">{formatDate(activity.activityDate)}</div>
         {activity.activityBy && (
        <div className="activity-by">By: {activity.activityBy}</div>
        )}
        {activity.action && (
          <div className={`activity-action action-${activity.action.toLowerCase()}`}>
            {activity.action}
          </div>
        )}
      </div>

      <div className="activity-description"><strong>{activity.activityDescription}</strong></div>

      {activity.comment && (
        <div className="activity-comment">
          <span className="comment-icon">💬</span>
          <span>{activity.comment}</span>
        </div>
      )}
      {activity.fileAttachmentId && (
        <div className="activity-attachment">
          <span className="attachment-icon">📎</span>
          <span>File attached (ID: {activity.fileAttachmentId})</span>
        </div>
      )}

        {activity.split !== null && activity.split !== undefined && (
            <div className="builder-split">
              Split: {activity.split}%: {formatCurrency(activity.splitAmount)}
            </div>
          )}
          {activity.deductionAmount !== null && activity.deductionAmount !== undefined && activity.deductionAmount >= 0 && (
            <div className="builder-deduction">
              Deductions: {formatCurrency(activity.deductionAmount)}
            </div>
          )}
    </div>
  );
};